type Jwt = {
  roles?: {
    [service: string]: string[];
  };
  abac?: {
    [key: string]: string[];
  };
  [key: string]: unknown;
};

const decodeJwt = (token: string): Jwt => {
  const base64Url = token.split(".")[1];
  if (!base64Url) {
    throw new Error("Invalid JWT token");
  }
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export default decodeJwt;
